(function () {
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatScore(score) {
    var value = parseFloat(score);
    if (isNaN(value)) return '';
    return value.toFixed(1);
  }

  function formatDate(iso) {
    if (!iso) return '';
    var date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function starsMarkup(score) {
    var count = Math.max(0, Math.min(5, Math.round(parseFloat(score) || 0)));
    var stars = '';
    for (var i = 0; i < 5; i += 1) {
      stars += i < count ? '★' : '☆';
    }
    return stars;
  }

  function truncate(text, max) {
    if (!text) return '';
    text = String(text).trim();
    if (text.length <= max) return text;
    return text.slice(0, max).trim() + '…';
  }

  /*
    Yotpo's thumb_url is roughly 200px square. The photo strip shows these at
    about 340px on desktop and near full width on mobile, which is where the
    pixellation came from — so take the full-size image and let the browser
    scale it down. Thumb is only the fallback for a review that has no
    original.
  */
  function getReviewImage(review) {
    if (!review || !review.images_data || !review.images_data.length) return null;
    var image = review.images_data[0];
    return image.original_url || image.image_url || image.thumb_url;
  }

  function getVerifiedLabel(review) {
    if (!review) return '';
    if (review.images_data && review.images_data.length) return 'Verified · with photo';
    if (review.verified_buyer) return 'Verified buyer';
    return '';
  }

  function buildApiUrl(appKey, productId, params) {
    var query = new URLSearchParams(params);
    return (
      'https://api-cdn.yotpo.com/v1/widget/' +
      encodeURIComponent(appKey) +
      '/products/' +
      encodeURIComponent(productId) +
      '/reviews.json?' +
      query.toString()
    );
  }

  function stripUndefined(value) {
    return JSON.parse(JSON.stringify(value));
  }

  /*
    The old chips searched the review text for a keyword. The form answers
    live on each review as custom_fields, and that is what these groups read.

    Titles are matched loosely ("Hair Volume" is the thickness question as
    Yotpo saved it). Values are compared with the edges trimmed, because
    several saved answers carry a trailing space. A friendlier label is only
    the chip text — the value is the string Yotpo stored.

    Hair length keeps a known order and then appends any other answer it
    finds, so a new option such as "Shoulder length" appears on its own.
    Age is not a group, so it never becomes a filter.
  */
  var FILTER_GROUPS = [
    {
      id: 'install',
      label: 'Install method',
      titles: ['install method'],
      control: 'chips',
      options: [
        { value: 'Self - Install', label: 'Self-install' },
        { value: 'Salon/Stylist Install', label: 'Salon install' }
      ]
    },
    {
      id: 'hair-type',
      label: 'Hair type',
      titles: ['hair type'],
      control: 'chips',
      options: [
        { value: '4A - C', label: '4A–4C hair' },
        { value: '3A - C', label: '3A–3C hair' },
        { value: '2A - C', label: '2A–2C hair' },
        { value: '1A - C', label: '1A–1C hair' }
      ]
    },
    {
      id: 'hair-length',
      label: 'Hair length',
      titles: ['hair length'],
      control: 'select',
      discover: true,
      options: [
        { value: 'shorter or up to ear length', label: 'Up to ear' },
        { value: 'Chin Length', label: 'Chin length' },
        { value: 'Mid-back Length', label: 'Mid-back' },
        { value: 'Past mid-back length', label: 'Past mid-back' }
      ]
    },
    {
      id: 'thickness',
      label: 'Hair thickness',
      titles: ['hair thickness', 'hair volume'],
      control: 'select',
      options: [
        { value: 'Extra Thin', label: 'Extra thin' },
        { value: 'Thin', label: 'Thin' },
        { value: 'Average', label: 'Average' },
        { value: 'Thick', label: 'Thick' },
        { value: 'Extra Thick', label: 'Extra thick' }
      ]
    }
  ];

  function norm(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function normTitle(value) {
    return norm(value).replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function titleMatches(title, keys) {
    var name = normTitle(title);
    if (!name || name === 'age') return false;
    return keys.some(function (key) {
      return name === key || name.indexOf(key) !== -1;
    });
  }

  function fieldList(review) {
    var fields = review && review.custom_fields;
    if (!fields) return [];
    var list = Array.isArray(fields) ? fields : Object.keys(fields).map(function (key) {
      return fields[key];
    });
    return list.filter(function (field) {
      return field && field.title;
    });
  }

  function closestFromEvent(event, selector) {
    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return null;
    return node.closest(selector);
  }

  function hasMedia(review) {
    if (!review) return false;
    if (review.images_data && review.images_data.length) return true;
    if (review.videos_data && review.videos_data.length) return true;
    return false;
  }

  function fetchReviews(appKey, productId, params) {
    return fetch(buildApiUrl(appKey, productId, params))
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || !data || !data.response || data.status && data.status.code !== 200) {
            return null;
          }
          return data.response;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function ReviewsHub(root) {
    this.root = root;
    this.appKey = root.getAttribute('data-app-key');
    this.productId = root.getAttribute('data-product-id');
    this.reviewsSuffix = root.getAttribute('data-reviews-suffix') || 'this product';
    this.initialCount = parseInt(root.getAttribute('data-initial-count') || '4', 10);
    this.showingText = root.dataset.showingText || '';
    this.loadMoreText = root.getAttribute('data-load-more-text') || 'Load more reviews';
    this.photoLimit = parseInt(root.getAttribute('data-photo-limit') || '7', 10);

    /*
      Review ids whose PHOTOS are withheld from the strip. Set per section in
      the theme editor. Kept as strings because Yotpo ids arrive as numbers in
      the API and as text in the setting.
    */
    this.hiddenPhotoReviews = (root.getAttribute('data-hidden-photo-reviews') || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
    this.groups = FILTER_GROUPS;
    this.selections = {};
    this.photoOn = false;
    this.sort = 'date';
    this.page = 1;
    this.perPage = 50;
    this.fetchGen = 0;
    this.restLoading = false;
    this.expanded = false;
    this.photosExpanded = false;
    this.loading = false;
    this.allReviews = [];
    this.bottomline = null;
    this.totalReviews = 0;
    this.modal = root.querySelector('[data-reviews-modal]');

    this.els = {
      photos: root.querySelector('[data-reviews-photos]'),
      photoTrack: root.querySelector('[data-reviews-photo-track]'),
      summary: root.querySelector('[data-reviews-summary]'),
      bars: root.querySelector('[data-reviews-bars]'),
      score: root.querySelector('[data-reviews-score]'),
      count: root.querySelector('[data-reviews-count]'),
      filters: root.querySelector('[data-reviews-filters]'),
      sort: root.querySelector('[data-reviews-sort]'),
      cards: root.querySelector('[data-reviews-cards]'),
      loadMore: root.querySelector('[data-reviews-load-more]'),
      showing: root.querySelector('[data-reviews-showing]'),
      status: root.querySelector('[data-reviews-status]'),
      modalBody: root.querySelector('[data-reviews-modal-body]'),
      modalClose: root.querySelector('[data-reviews-modal-close]'),
      writeBtn: root.querySelector('[data-reviews-write-btn]')
    };

    this.writeReviewUrl = root.getAttribute('data-write-review-url') || '';

    this.bindEvents();
    this.bindClaims();
    this.initWriteReviewLink();
    this.renderFilters();
    this.loadInitial();
  }

  /*
    The proof blocks wait on an IntersectionObserver, so their claim can land
    after this strip has already rendered. Re-render when it does — that way
    the result is the same whichever section finishes first.
  */
  ReviewsHub.prototype.bindClaims = function () {
    var self = this;
    if (!window.AsYotpoClaims) return;

    window.AsYotpoClaims.subscribe(function () {
      if (!self.allReviews.length) return;
      self.renderPhotos();
    });
  };

  ReviewsHub.prototype.initWriteReviewLink = function () {
    if (!this.els.writeBtn || !this.appKey || !this.productId) return;

    var productName = this.root.getAttribute('data-product-name') || '';
    var params = new URLSearchParams();

    params.set('appkey', this.appKey);
    params.set('sku', this.productId);
    params.set('email_type', 'review_request_link_product');
    params.set('page_title', 'Please write a review');
    if (productName) params.set('product_title', productName);
    params.set('review_accept_one_field', 'true');
    params.set('review_images', 'true');
    params.set('review_source', 'review_request_link_product');
    params.set('review_title_required', 'true');
    params.set('skip_share', 'false');
    params.set('ref', 'yotpo');

    this.writeReviewUrl = 'https://landing-pages.yotpo.com/base/#/review?' + params.toString();
    this.els.writeBtn.href = this.writeReviewUrl;
    this.els.writeBtn.setAttribute('target', '_blank');
    this.els.writeBtn.setAttribute('rel', 'noopener noreferrer');
  };

  ReviewsHub.prototype.bindEvents = function () {
    var self = this;

    if (this.els.sort) {
      this.els.sort.addEventListener('change', function (event) {
        self.onSortChange(event.target.value);
      });
    }

    if (this.els.loadMore) {
      this.els.loadMore.addEventListener('click', function () {
        if (!self.expanded) {
          self.expanded = true;
          self.root.classList.add('is-expanded');
          self.renderCards();
          self.updateLoadMore();
          return;
        }

        var filteredCount = self.getFilteredReviews().length;
        var visibleCount = self.expanded
          ? filteredCount
          : Math.min(self.initialCount, filteredCount);
        var hasHiddenInMemory = filteredCount > visibleCount;

        if (hasHiddenInMemory) {
          self.renderCards();
          self.updateLoadMore();
          return;
        }

        if (self.restLoading) return;

        if (self.allReviews.length < self.totalReviews) {
          self.page += 1;
          self.loadMoreReviews();
        }
      });
    }

    if (this.els.filters) {
      this.els.filters.addEventListener('click', function (event) {
        if (closestFromEvent(event, '[data-filter-clear]')) {
          self.clearFilters();
          return;
        }

        if (closestFromEvent(event, '[data-filter-photo]')) {
          self.onPhotoToggle();
          return;
        }

        var button = closestFromEvent(event, '[data-filter-value]');
        if (!button) return;
        self.onGroupToggle(button.getAttribute('data-filter-group'), button.getAttribute('data-filter-value'));
      });

      this.els.filters.addEventListener('change', function (event) {
        var select = closestFromEvent(event, '[data-filter-select]');
        if (!select) return;
        self.onGroupToggle(select.getAttribute('data-filter-group'), select.value);
      });
    }

    if (this.els.cards) {
      this.els.cards.addEventListener('click', function (event) {
        var card = event.target.closest('[data-review-id]');
        if (!card) return;
        var reviewId = card.getAttribute('data-review-id');
        var review = self.allReviews.find(function (item) {
          return String(item.id) === String(reviewId);
        });
        if (review) self.openModal(review);
      });
    }

    if (this.els.photoTrack) {
      this.els.photoTrack.addEventListener('click', function (event) {
        var expandBtn = event.target.closest('[data-photo-expand]');
        if (expandBtn) {
          self.photosExpanded = true;
          self.renderPhotos();
          return;
        }

        var button = event.target.closest('[data-review-id]');
        if (!button) return;
        var reviewId = button.getAttribute('data-review-id');
        var review = self.allReviews.find(function (item) {
          return String(item.id) === String(reviewId);
        });
        if (review) self.openModal(review);
      });
    }

    if (this.els.modalClose) {
      this.els.modalClose.addEventListener('click', function () {
        self.closeModal();
      });
    }
  };

  ReviewsHub.prototype.handleModalOutsideClick = function (event) {
    if (!this.modal || !this.modal.open) return;

    var inner = this.modal.querySelector('.yotpo-reviews-hub__modal-inner');
    if (inner && inner.contains(event.target)) return;

    this.closeModal();
  };

  ReviewsHub.prototype.bindModalOutsideClick = function () {
    var self = this;

    this.unbindModalOutsideClick();

    this._boundOutsideClick = function (event) {
      self.handleModalOutsideClick(event);
    };

    window.setTimeout(function () {
      if (!self.modal || !self.modal.open || !self._boundOutsideClick) return;
      document.addEventListener('click', self._boundOutsideClick, true);
    }, 0);
  };

  ReviewsHub.prototype.unbindModalOutsideClick = function () {
    if (this._boundOutsideClick) {
      document.removeEventListener('click', this._boundOutsideClick, true);
      this._boundOutsideClick = null;
    }
  };

  ReviewsHub.prototype.setLoading = function (isLoading) {
    this.loading = isLoading;
    this.root.classList.toggle('is-loading', isLoading);
    if (this.els.loadMore) this.els.loadMore.disabled = isLoading;
  };

  ReviewsHub.prototype.isPhotoFilterActive = function () {
    return this.photoOn;
  };

  ReviewsHub.prototype.hasAnswerFilter = function () {
    var self = this;
    if (this.photoOn) return true;
    return this.groups.some(function (group) {
      return !!self.selections[group.id];
    });
  };

  ReviewsHub.prototype.answerFor = function (review, group) {
    var fields = fieldList(review);
    for (var i = 0; i < fields.length; i += 1) {
      if (titleMatches(fields[i].title, group.titles)) return fields[i].value;
    }
    return '';
  };

  ReviewsHub.prototype.optionsFor = function (group) {
    var options = group.options.slice();
    var seen = {};
    options.forEach(function (option) {
      seen[norm(option.value)] = true;
    });
    if (!group.discover) return options;

    var self = this;
    this.allReviews.forEach(function (review) {
      var value = self.answerFor(review, group);
      var key = norm(value);
      if (!key || seen[key]) return;
      seen[key] = true;
      options.push({ value: String(value).replace(/\s+/g, ' ').trim(), label: String(value).replace(/\s+/g, ' ').trim() });
    });
    return options;
  };

  ReviewsHub.prototype.setSortSelectValue = function (value) {
    this.sort = value;
    if (this.els.sort) this.els.sort.value = value;
  };

  ReviewsHub.prototype.reloadReviews = function () {
    this.page = 1;
    this.allReviews = [];
    this.loadInitial();
  };

  ReviewsHub.prototype.onSortChange = function (newSort) {
    this.setSortSelectValue(newSort);
    this.applyClientSort();
    this.renderCards();
    this.renderPhotos();
    this.updateLoadMore();
  };

  ReviewsHub.prototype.clearFilters = function () {
    this.selections = {};
    this.photoOn = false;
    this.renderFilters();
    this.renderCards();
    this.renderPhotos();
    this.updateLoadMore();
  };

  ReviewsHub.prototype.onGroupToggle = function (groupId, value) {
    if (!groupId) return;

    if (!value || (this.selections[groupId] && norm(this.selections[groupId]) === norm(value))) {
      delete this.selections[groupId];
    } else {
      this.selections[groupId] = value;
    }

    this.renderFilters();
    this.renderCards();
    this.renderPhotos();
    this.updateLoadMore();
  };

  ReviewsHub.prototype.onPhotoToggle = function () {
    this.photoOn = !this.photoOn;
    this.renderFilters();
    this.renderCards();
    this.renderPhotos();
    this.updateLoadMore();
  };

  ReviewsHub.prototype.getSortParams = function () {
    if (this.sort === 'helpful') {
      return { sort: 'votes_up', direction: 'desc' };
    }
    if (this.sort === 'highest') {
      return { sort: 'rating', direction: 'desc' };
    }
    if (this.sort === 'lowest') {
      return { sort: 'rating', direction: 'asc' };
    }
    if (this.sort === 'photos') {
      return { sort: 'date', direction: 'desc' };
    }
    return { sort: 'date', direction: 'desc' };
  };

  ReviewsHub.prototype.applyClientSort = function () {
    var sort = this.sort;

    this.allReviews.sort(function (a, b) {
      if (sort === 'photos') {
        var photoDiff = (hasMedia(b) ? 1 : 0) - (hasMedia(a) ? 1 : 0);
        if (photoDiff !== 0) return photoDiff;
      }

      if (sort === 'highest' || sort === 'lowest') {
        var scoreDiff = (parseFloat(a.score) || 0) - (parseFloat(b.score) || 0);
        if (scoreDiff !== 0) return sort === 'lowest' ? scoreDiff : -scoreDiff;
      }

      if (sort === 'helpful') {
        var voteDiff = (b.votes_up || 0) - (a.votes_up || 0);
        if (voteDiff !== 0) return voteDiff;
      }

      return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
    });
  };

  ReviewsHub.prototype.loadInitial = function () {
    var self = this;
    this.fetchGen += 1;
    var gen = this.fetchGen;
    this.restLoading = false;
    this.setLoading(true);
    this.page = 1;
    this.expanded = false;
    this.root.classList.remove('is-expanded');

    var sortParams = this.getSortParams();

    fetchReviews(this.appKey, this.productId, {
      per_page: this.perPage,
      page: 1,
      sort: sortParams.sort,
      direction: sortParams.direction
    }).then(function (response) {
      if (gen !== self.fetchGen) return;
      self.setLoading(false);

      if (!response) {
        self.showStatus('Reviews are unavailable right now.');
        return;
      }

      self.bottomline = response.bottomline || null;
      self.allReviews = response.reviews || [];
      self.applyClientSort();
      self.totalReviews =
        (response.bottomline && response.bottomline.total_review) ||
        (response.pagination && response.pagination.total) ||
        self.allReviews.length;

      self.renderSummary();
      self.renderPhotos();
      self.renderFilters();
      if (self.els.status) self.els.status.textContent = '';
      self.renderCards();
      self.updateLoadMore();
      self.updateJsonLd();
      self.loadRest(gen);
    });
  };

  /*
    A filter has to see every saved answer, not just the first page. Later
    pages fill in behind the first paint, and a new hair-length answer is
    added to its menu as soon as a review carrying it arrives.
  */
  ReviewsHub.prototype.loadRest = function (gen) {
    var self = this;
    if (this.allReviews.length >= this.totalReviews || this.page >= 20) return;
    this.restLoading = true;

    var sortParams = this.getSortParams();
    this.page += 1;

    fetchReviews(this.appKey, this.productId, {
      per_page: this.perPage,
      page: this.page,
      sort: sortParams.sort,
      direction: sortParams.direction
    }).then(function (response) {
      if (gen !== self.fetchGen) return;

      var reviews = response && response.reviews;
      if (!reviews || !reviews.length) {
        self.restLoading = false;
        self.renderFilters();
        self.updateLoadMore();
        return;
      }

      var existingIds = {};
      self.allReviews.forEach(function (review) {
        existingIds[review.id] = true;
      });
      reviews.forEach(function (review) {
        if (!existingIds[review.id]) self.allReviews.push(review);
      });

      self.applyClientSort();
      if (self.optionsSignature() !== self._filterSignature) self.renderFilters();
      self.renderCards();
      self.renderPhotos();
      self.updateLoadMore();

      if (self.allReviews.length < self.totalReviews && self.page < 20) {
        self.loadRest(gen);
        return;
      }

      self.restLoading = false;
      self.updateLoadMore();
    });
  };

  ReviewsHub.prototype.loadMoreReviews = function () {
    var self = this;
    if (this.loading) return;

    this.setLoading(true);
    var sortParams = this.getSortParams();

    fetchReviews(this.appKey, this.productId, {
      per_page: this.perPage,
      page: this.page,
      sort: sortParams.sort,
      direction: sortParams.direction
    }).then(function (response) {
      self.setLoading(false);
      if (!response || !response.reviews) return;

      var existingIds = {};
      self.allReviews.forEach(function (review) {
        existingIds[review.id] = true;
      });

      response.reviews.forEach(function (review) {
        if (!existingIds[review.id]) self.allReviews.push(review);
      });

      self.applyClientSort();
      self.renderFilters();
      self.renderPhotos();
      self.renderCards();
      self.updateLoadMore();
      self.updateJsonLd();
    });
  };

  ReviewsHub.prototype.updateJsonLd = function () {
    var sectionId = this.root.getAttribute('data-section-id');
    var script = document.getElementById('yotpo-reviews-jsonld-' + sectionId);
    if (!script || !this.bottomline) return;

    var productName = this.root.getAttribute('data-product-name');
    var productUrl = this.root.getAttribute('data-product-url');
    var productImage = this.root.getAttribute('data-product-image');
    var averageScore = formatScore(this.bottomline.average_score);
    var totalReviews = this.bottomline.total_review || this.totalReviews;

    var reviewItems = this.allReviews.slice(0, 10).map(function (review) {
      var item = {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: (review.user && review.user.display_name) || 'Customer'
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: String(review.score || 5),
          bestRating: '5',
          worstRating: '1'
        }
      };

      if (review.created_at) {
        item.datePublished = review.created_at.split('T')[0];
      }

      if (review.title) item.name = review.title;
      if (review.content) item.reviewBody = review.content;

      return item;
    });

    var payload = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: productName,
      url: productUrl,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: averageScore,
        reviewCount: String(totalReviews),
        bestRating: '5',
        worstRating: '1'
      },
      review: reviewItems
    };

    if (productImage) payload.image = productImage;

    script.textContent = JSON.stringify(stripUndefined(payload));
  };

  ReviewsHub.prototype.renderSummary = function () {
    if (!this.bottomline) return;

    var average = formatScore(this.bottomline.average_score);
    var total = this.bottomline.total_review || this.totalReviews;

    if (this.els.score) {
      this.els.score.textContent = average ? average + ' ★' : '';
    }

    if (this.els.count) {
      this.els.count.textContent = total + ' reviews (' + this.reviewsSuffix + ')';
    }

    if (this.els.bars && this.bottomline.star_distribution) {
      var distribution = this.bottomline.star_distribution;
      var maxCount = 0;
      [5, 4, 3, 2, 1].forEach(function (star) {
        maxCount = Math.max(maxCount, parseInt(distribution[star] || 0, 10));
      });

      this.els.bars.innerHTML = [5, 4, 3, 2, 1]
        .map(function (star) {
          var count = parseInt(distribution[star] || 0, 10);
          var width = maxCount ? Math.round((count / maxCount) * 100) : 0;
          return (
            '<div class="yotpo-reviews-hub__bar-row">' +
              '<span class="yotpo-reviews-hub__bar-label">' + star + '★</span>' +
              '<span class="yotpo-reviews-hub__bar-track">' +
                '<span class="yotpo-reviews-hub__bar-fill" style="width:' + width + '%"></span>' +
              '</span>' +
              '<span class="yotpo-reviews-hub__bar-count">' + count + '</span>' +
            '</div>'
          );
        })
        .join('');
    }
  };

  /*
    Photos already used by the proof blocks are skipped — the same face should
    not appear twice on one page. See as-yotpo-claims.js for the register.

    Only the photo STRIP filters. The review itself can still appear as a card,
    since that is its words rather than its picture.
  */
  ReviewsHub.prototype.optionsSignature = function () {
    var self = this;
    return this.groups
      .map(function (group) {
        if (!group.discover) return group.id;
        return (
          group.id +
          ':' +
          self
            .optionsFor(group)
            .map(function (option) {
              return norm(option.value);
            })
            .join('|')
        );
      })
      .join('~');
  };

  ReviewsHub.prototype.getPhotoReviews = function () {
    var claims = window.AsYotpoClaims;
    var hidden = this.hiddenPhotoReviews;

    return this.getFilteredReviews().filter(function (review) {
      if (!review.images_data || !review.images_data.length) return false;
      if (claims && claims.has(review.id)) return false;
      if (hidden.indexOf(String(review.id)) !== -1) return false;
      return true;
    });
  };

  ReviewsHub.prototype.renderPhotos = function () {
    if (!this.els.photoTrack) return;

    var photoReviews = this.getPhotoReviews();
    if (!photoReviews.length) {
      var emptyPhotos = this.hasAnswerFilter()
        ? 'No customer photos for this filter.'
        : 'No customer photos yet.';
      this.els.photoTrack.innerHTML = '<p class="yotpo-reviews-hub__empty">' + emptyPhotos + '</p>';
      this.els.photoTrack.classList.remove('is-expanded');
      return;
    }

    var showAll = this.photosExpanded || photoReviews.length <= this.photoLimit;
    var visible = showAll ? photoReviews : photoReviews.slice(0, this.photoLimit);
    var html = visible
      .map(function (review) {
        var image = getReviewImage(review);
        return (
          '<button type="button" class="yotpo-reviews-hub__photo-btn" data-review-id="' +
          review.id +
          '" aria-label="Open review by ' +
          escapeHtml(review.user && review.user.display_name ? review.user.display_name : 'customer') +
          '">' +
          '<img src="' +
          escapeHtml(image) +
          '" alt="" loading="lazy">' +
          '</button>'
        );
      })
      .join('');

    if (!showAll) {
      html +=
        '<button type="button" class="yotpo-reviews-hub__photo-btn yotpo-reviews-hub__photo-more" data-photo-expand aria-label="Show all customer photos">+' +
        (photoReviews.length - this.photoLimit) +
        '</button>';
    }

    this.els.photoTrack.innerHTML = html;
    this.els.photoTrack.classList.toggle('is-expanded', showAll);
  };

  ReviewsHub.prototype.renderFilters = function () {
    if (!this.els.filters) return;

    var self = this;
    var allActive = !this.hasAnswerFilter();
    var html =
      '<div class="yotpo-reviews-hub__filter-row">' +
      '<button type="button" class="yotpo-reviews-hub__filter' +
      (allActive ? ' is-active' : '') +
      '" data-filter-clear aria-pressed="' +
      (allActive ? 'true' : 'false') +
      '">All</button>' +
      '<button type="button" class="yotpo-reviews-hub__filter' +
      (this.photoOn ? ' is-active' : '') +
      '" data-filter-photo aria-pressed="' +
      (this.photoOn ? 'true' : 'false') +
      '">With photos</button>' +
      '</div>';

    var selects = '';

    this.groups.forEach(function (group) {
      var options = self.optionsFor(group);
      var selected = self.selections[group.id] || '';

      if (group.control === 'select') {
        selects +=
          '<label class="yotpo-reviews-hub__filter-select-wrap">' +
          '<span class="visually-hidden">' +
          escapeHtml(group.label) +
          '</span>' +
          '<select class="yotpo-reviews-hub__filter-select' +
          (selected ? ' is-active' : '') +
          '" data-filter-select data-filter-group="' +
          escapeHtml(group.id) +
          '" aria-label="' +
          escapeHtml(group.label) +
          '">' +
          '<option value="">' +
          escapeHtml(group.label) +
          '</option>' +
          options
            .map(function (option) {
              var isSelected = selected && norm(selected) === norm(option.value);
              return (
                '<option value="' +
                escapeHtml(option.value) +
                '"' +
                (isSelected ? ' selected' : '') +
                '>' +
                escapeHtml(option.label) +
                '</option>'
              );
            })
            .join('') +
          '</select></label>';
        return;
      }

      html +=
        '<div class="yotpo-reviews-hub__filter-set">' +
        '<span class="yotpo-reviews-hub__filter-name">' +
        escapeHtml(group.label) +
        '</span>' +
        options
          .map(function (option) {
            var isSelected = selected && norm(selected) === norm(option.value);
            return (
              '<button type="button" class="yotpo-reviews-hub__filter' +
              (isSelected ? ' is-active' : '') +
              '" data-filter-group="' +
              escapeHtml(group.id) +
              '" data-filter-value="' +
              escapeHtml(option.value) +
              '" aria-pressed="' +
              (isSelected ? 'true' : 'false') +
              '">' +
              escapeHtml(option.label) +
              '</button>'
            );
          })
          .join('') +
        '</div>';
    });

    if (selects) {
      html += '<div class="yotpo-reviews-hub__filter-selects">' + selects + '</div>';
    }

    this.els.filters.innerHTML = html;
    this._filterSignature = this.optionsSignature();
  };

  ReviewsHub.prototype.getFilteredReviews = function () {
    var self = this;

    return this.allReviews.filter(function (review) {
      if (self.photoOn && !hasMedia(review)) return false;

      for (var i = 0; i < self.groups.length; i += 1) {
        var group = self.groups[i];
        var wanted = self.selections[group.id];
        if (!wanted) continue;
        if (norm(self.answerFor(review, group)) !== norm(wanted)) return false;
      }

      return true;
    });
  };

  ReviewsHub.prototype.renderCards = function () {
    if (!this.els.cards) return;

    var reviews = this.getFilteredReviews();
    var limit = this.expanded ? reviews.length : this.initialCount;
    var visible = reviews.slice(0, limit);

    if (!visible.length) {
      this.els.cards.innerHTML = '<p class="yotpo-reviews-hub__empty">No reviews match this filter.</p>';
      return;
    }

    /*
      Card layout follows the design: a row of stars with the meta pushed to
      the opposite end, the quote beneath, then the attribution. The thumbnail
      that used to lead each card is gone — customer photos have their own
      strip above, and repeating them here made every card start with a
      picture of something already on screen.
    */
    this.els.cards.innerHTML = visible
      .map(function (review) {
        var badge = getVerifiedLabel(review);
        var meta = badge || (review.created_at ? formatDate(review.created_at) : '');
        var name = (review.user && review.user.display_name) || 'Customer';

        return (
          '<button type="button" class="yotpo-reviews-hub__card" data-review-id="' +
          review.id +
          '">' +
          '<div class="yotpo-reviews-hub__card-top">' +
          '<span class="yotpo-reviews-hub__card-stars" aria-hidden="true">' +
          starsMarkup(review.score) +
          '</span>' +
          (meta ? '<span class="yotpo-reviews-hub__card-badge">' + escapeHtml(meta) + '</span>' : '') +
          '</div>' +
          '<p class="yotpo-reviews-hub__card-text">' +
          escapeHtml(truncate(review.content || review.title, 180)) +
          '</p>' +
          '<span class="yotpo-reviews-hub__card-author">&mdash; ' +
          '<span class="yotpo-reviews-hub__card-name">' +
          escapeHtml(name) +
          '</span> · Verified</span>' +
          '</button>'
        );
      })
      .join('');
  };

  ReviewsHub.prototype.updateLoadMore = function () {
    if (!this.els.loadMore) return;

    var filteredCount = this.getFilteredReviews().length;
    var visibleCount = this.expanded
      ? filteredCount
      : Math.min(this.initialCount, filteredCount);
    var hasHiddenInMemory = filteredCount > visibleCount;
    var hasMorePages = this.allReviews.length < this.totalReviews;

    var total = this.hasAnswerFilter()
      ? filteredCount
      : Math.max(filteredCount, this.totalReviews || 0);
    this.updateShowing(visibleCount, total);

    if (!hasHiddenInMemory && !hasMorePages) {
      this.els.loadMore.hidden = true;
      return;
    }

    this.els.loadMore.hidden = false;
    this.els.loadMore.textContent = this.loadMoreText;
  };

  /* "Showing 6 of 312" under the button. Blank when the merchant has not
     authored a template, so it is opt-in rather than a stray line. */
  ReviewsHub.prototype.updateShowing = function (shown, total) {
    if (!this.els.showing) return;

    if (!this.showingText || !total) {
      this.els.showing.textContent = '';
      return;
    }

    this.els.showing.textContent = this.showingText
      .replace('[shown]', String(shown))
      .replace('[total]', String(total));
  };

  ReviewsHub.prototype.showStatus = function (message) {
    if (this.els.status) this.els.status.textContent = message;
    if (this.els.cards) this.els.cards.innerHTML = '';
    if (this.els.photoTrack) this.els.photoTrack.innerHTML = '';
    if (this.els.loadMore) this.els.loadMore.hidden = true;
  };

  ReviewsHub.prototype.openModal = function (review) {
    if (!this.modal || !this.els.modalBody) return;

    var images =
      review.images_data && review.images_data.length
        ? review.images_data
            .map(function (image) {
              return (
                '<img src="' +
                escapeHtml(image.original_url || image.thumb_url) +
                '" alt="" loading="lazy">'
              );
            })
            .join('')
        : '';

    var reply = '';
    if (review.comment && review.comment.content) {
      reply =
        '<div class="yotpo-reviews-hub__modal-reply">' +
        '<p class="yotpo-reviews-hub__modal-reply-label">Store response</p>' +
        '<p>' +
        escapeHtml(review.comment.content) +
        '</p>' +
        '</div>';
    }

    this.els.modalBody.innerHTML =
      /*
        Title leads on its own line, then a meta row of stars and attribution
        beneath it. All three used to be children of the same flex row, which
        on a narrow screen squeezed the title into a column one word wide.
      */
      (review.title
        ? '<h3 class="yotpo-reviews-hub__modal-title">' + escapeHtml(review.title) + '</h3>'
        : '') +
      '<div class="yotpo-reviews-hub__modal-header">' +
      '<span class="yotpo-reviews-hub__card-stars" aria-label="' +
      escapeHtml(review.score + ' out of 5 stars') +
      '">' +
      starsMarkup(review.score) +
      '</span>' +
      '<span class="yotpo-reviews-hub__modal-author">' +
      escapeHtml(review.user && review.user.display_name ? review.user.display_name : 'Customer') +
      (getVerifiedLabel(review) ? ' · ' + escapeHtml(getVerifiedLabel(review)) : '') +
      (review.created_at ? ' · ' + escapeHtml(formatDate(review.created_at)) : '') +
      '</span>' +
      '</div>' +
      (images ? '<div class="yotpo-reviews-hub__modal-images">' + images + '</div>' : '') +
      '<p class="yotpo-reviews-hub__modal-content">' +
      escapeHtml(review.content || '') +
      '</p>' +
      reply;

    if (typeof this.modal.showModal === 'function') {
      this.modal.showModal();
    } else {
      this.modal.setAttribute('open', '');
    }

    this.bindModalOutsideClick();
  };

  ReviewsHub.prototype.closeModal = function () {
    if (!this.modal) return;

    this.unbindModalOutsideClick();

    if (typeof this.modal.close === 'function') {
      this.modal.close();
    } else {
      this.modal.removeAttribute('open');
    }
  };

  function initAll() {
    document.querySelectorAll('[data-yotpo-reviews-hub]').forEach(function (root) {
      if (root.dataset.hubInit === 'true') return;
      root.dataset.hubInit = 'true';
      new ReviewsHub(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
